<template>
  <v-card-text>
    <v-row>
      <v-col class="text-right">
        <v-btn
          :loading="loadingCheckin"
          x-large
          color="success"
          @click="sendCheckIn()"
        >
          Check-In
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AutocompleteSearchGuest v-model="guest" />
      </v-col>
    </v-row>
    <v-row
      no-gutters
      class="mt-2"
    >
      <v-col cols="6">
        <v-select
          v-model="transport_type"
          :items="meiosTransporte"
          item-text="label"
          item-value="codigo"
          outlined
          label="Meio de Transporte"
          clearable
          class="mr-2"
        />
      </v-col>
      <v-col cols="6">
        <v-select
          v-model="travel_reason"
          :items="motivosViagem"
          item-text="label"
          item-value="codigo"
          outlined
          label="Motivo da Viagem"
          clearable
        />
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { mapActions } from 'vuex'
import AutocompleteSearchGuest from '@/components/AutocompleteSearchGuest.vue'

export default {
  components: {
    AutocompleteSearchGuest,
  },
  props: {
    room: {
      type: Object,
    },
  },
  data: () => ({
    loadingCheckin: false,
    guest: null,
    transport_type: null,
    travel_reason: null,
    meiosTransporte: [],
    motivosViagem: [],
  }),
  created() {
    this.loadFnrhDominios()
    const guests = this.room?.current_reserve?.guest
    if (guests && guests.length > 0) {
      this.guest = guests[0]
    }
  },
  methods: {
    ...mapActions('reserved', ['checkIn']),
    ...mapActions('select', ['get_fnrh_dominios']),
    async loadFnrhDominios() {
      const [transport, reason] = await Promise.all([
        this.get_fnrh_dominios('meios_transporte'),
        this.get_fnrh_dominios('motivos_viagem'),
      ])
      this.meiosTransporte = transport.data
      this.motivosViagem = reason.data
    },
    sendCheckIn() {
      this.loadingCheckin = true
      this.room.guest = this.guest ? [this.guest] : []
      this.room.transport_type = this.transport_type
      this.room.travel_reason = this.travel_reason
      this.checkIn(this.room).then(response => {
        this.$emit('close')
        this.$toast.success('Check-In realizado')
        this.$emit('updategrid')
      }).finally(() => {
        this.loadingCheckin = false
      })
    },
  },
}
</script>
